import { StudentServicePath, WEEKLY_SCHEDULE_DISCIPLINES } from "utils/constants";
import ListWeeklyScheduleDisciplines from "./List";

//permissions
export const resources = {
  isMenu: false,
  // icon: <EventNoteIcon />,
  name: StudentServicePath + WEEKLY_SCHEDULE_DISCIPLINES,
  title: "Седмично разписание",
  list: <ListWeeklyScheduleDisciplines />,
  // create: <CreateWeeklySchedule />,
  // createPermission: permissions.canCreateWeeklySchedule,
  //   edit: <EditWeeklySchedule />,
  //   editPermission: permissions.canUpdateWeeklySchedule,
  // permission: permissions.canPreviewWeeklySchedule,
};
